import { render, staticRenderFns } from "./DxfViewer.vue?vue&type=template&id=a70ae91e&scoped=true"
import script from "./DxfViewer.vue?vue&type=script&lang=js"
export * from "./DxfViewer.vue?vue&type=script&lang=js"
import style0 from "./DxfViewer.vue?vue&type=style&index=0&id=a70ae91e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ae91e",
  null
  
)

export default component.exports